import { render, staticRenderFns } from "./DropdownNavigation.vue?vue&type=template&id=3818d7fc&"
import script from "./DropdownNavigation.vue?vue&type=script&lang=js&"
export * from "./DropdownNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DropdownNavigation.vue?vue&type=style&index=0&id=3818d7fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports